import { BaseApi } from './base.api.js';

export class RiskApi extends BaseApi {
    constructor(client) {
        super(client, '/risk');
    }

}
